import { Check, Minus } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const ROWS = [
  {
    aspect: "Durability",
    chwa: "1680D ballistic nylon, bar-tack stitching, molded waterproof base",
    generic: "Thin polyester that frays within a season",
  },
  {
    aspect: "Organization",
    chwa: "43 purpose-built pockets, modular dividers, full tool visibility",
    generic: "One dark cavern where tools go to disappear",
  },
  {
    aspect: "Comfort",
    chwa: "Load-bearing padded harness engineered for all-day carry",
    generic: "Thin straps that dig in by noon",
  },
  {
    aspect: "Construction",
    chwa: "Oversized zippers, rubberized hardware, lifetime mindset",
    generic: "Disposable zippers and plastic fittings",
  },
];

export default function Compare() {
  return (
    <section id="why" data-testid="compare-section" className="border-t border-zinc-800 bg-[#0D0D0D]">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <SectionLabel index="05" title="Why CHWA" />
            <h2 className="mt-8 font-display text-4xl font-semibold uppercase leading-[0.95] tracking-tight text-zinc-50 sm:text-5xl lg:text-7xl">
              CHWA vs.<br />Generic Bags
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-zinc-500">
            The difference is not marketing. It is material, construction and intent — line by line.
          </p>
        </Reveal>

        <div className="mt-16 md:mt-24">
          <div className="grid grid-cols-1 gap-2 border-b border-zinc-700 pb-6 text-xs uppercase tracking-[0.3em] text-zinc-500 md:grid-cols-12">
            <span className="md:col-span-3">Standard</span>
            <span className="font-semibold text-zinc-50 md:col-span-5">CHWA</span>
            <span className="md:col-span-4">Generic Tool Bags</span>
          </div>

          {ROWS.map((r, i) => (
            <Reveal key={r.aspect} delay={0.05 * i} y={16}>
              <div data-testid={`compare-row-${r.aspect.toLowerCase()}`} className="grid grid-cols-1 gap-4 border-b border-zinc-800 py-8 md:grid-cols-12 md:py-10">
                <h3 className="font-display text-xl font-semibold uppercase tracking-tight text-zinc-100 md:col-span-3 md:text-2xl">
                  {r.aspect}
                </h3>
                <div className="flex items-start gap-3 md:col-span-5">
                  <Check size={18} className="mt-1 shrink-0 text-zinc-50" />
                  <p className="text-base leading-relaxed text-zinc-200">{r.chwa}</p>
                </div>
                <div className="flex items-start gap-3 md:col-span-4">
                  <Minus size={18} className="mt-1 shrink-0 text-zinc-600" />
                  <p className="text-base leading-relaxed text-zinc-500">{r.generic}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
